// 问卷状态枚举
export const QuestionnaireStatusEnum = {
  ALL: '',
  NOT_STARTED: 'not_started',  // 未开始
  ONGOING: 'ongoing',          // 进行中
  ENDED: 'ended'               // 已结束
};

// 状态显示配置
export const StatusConfig = {
  [QuestionnaireStatusEnum.NOT_STARTED]: {
    text: '未开始',
    color: 'default',
    style: { backgroundColor: '#f5f5f5', color: '#666', border: '1px solid #d9d9d9' }  // 浅灰色背景 + 中灰色文字
  },
  [QuestionnaireStatusEnum.ONGOING]: {
    text: '进行中',
    color: 'green'    // 绿色标识
  },
  [QuestionnaireStatusEnum.ENDED]: {
    text: '已结束',
    color: 'red'      // 红色标识
  }
};

// 操作类型枚举（用于权限控制）
export const ActionType = {
  VIEW: 'view',
  EDIT: 'edit',
  DELETE: 'delete',
  END: 'end',
  GENERATE_LINK: 'generateLink'
};

// 表格列配置
export const TableColumns = [
  {
    title: '问卷编号',
    dataIndex: 'questionnaireNo',
    key: 'questionnaireNo',
    width: 180
  },
  {
    title: '问卷标题',
    key: 'questionnaireTitle',
    width: 300,
    scopedSlots: { customRender: 'questionnaireTitle' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 120,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '提交数量',
    dataIndex: 'submitCount',
    key: 'submitCount',
    width: 120,
    align: 'center'
  },
  {
    title: '生效时间',
    dataIndex: 'effectiveTime',
    key: 'effectiveTime',
    width: 180
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 180
  },
  {
    title: '操作',
    key: 'action',
    width: 150,
    scopedSlots: { customRender: 'action' }
  }
];
